import { coreClient } from './coreclient'

export default {
  async sendError(text: string) {
    const client = await coreClient()
    await client.slack.sendErrorMessage({ text })
  }
}
